import React, { useState } from 'react';

function StatItem({ icon, label, value }) {
  return (
    <div className="curriculum-stat">
      <span className="curriculum-stat-icon" aria-hidden>
        {icon}
      </span>
      <div>
        <strong>{value}</strong>
        <span>{label}</span>
      </div>
    </div>
  );
}

export default function CourseCurriculum({ curriculum, hasBrochure, onBrochure, courseName }) {
  const [activeYearIndex, setActiveYearIndex] = useState(0);

  if (!curriculum?.years?.length) {
    return null;
  }

  const activeYear = curriculum.years[activeYearIndex] || curriculum.years[0];

  return (
    <section className="curriculum-section">
      <div className="curriculum-inner">
        <h2 className="curriculum-title">Course Curriculum</h2>

        <div className="curriculum-stats-row">
          <StatItem icon="◷" label="Duration" value={`${curriculum.durationMonths} months`} />
          <StatItem icon="▦" label="Commitment" value={`${curriculum.hoursPerWeek} Hours Per Week`} />
          <StatItem icon="☑" label="Structure" value={`${curriculum.semesters} Sem`} />
          <StatItem icon="★" label="Credits" value={`${curriculum.credits} Credits`} />
        </div>

        <div className="curriculum-toolbar">
          <div className="curriculum-year-tabs">
            {curriculum.years.map((year, index) => (
              <button
                key={year.id || year.label}
                type="button"
                className={`curriculum-year-tab ${index === activeYearIndex ? 'active' : ''}`}
                onClick={() => setActiveYearIndex(index)}
              >
                {year.label}
              </button>
            ))}
          </div>

          <button
            type="button"
            className="curriculum-download-btn"
            data-lead-intent="brochure"
            onClick={onBrochure}
          >
            {hasBrochure ? 'Download Brochure' : 'Request Brochure'}
            <span aria-hidden>{hasBrochure ? '↓' : '→'}</span>
          </button>
        </div>

        <div className="curriculum-semester-grid">
          {activeYear.semesters.map((semester) => (
            <article
              key={`${activeYear.label}-${semester.label}`}
              className="curriculum-semester-card"
            >
              <span className={`curriculum-semester-label accent-${semester.accent || 'blue'}`}>
                {semester.label}
              </span>
              <ul className="curriculum-subject-list">
                {semester.subjects.map((subject) => (
                  <li key={subject}>{subject}</li>
                ))}
              </ul>
            </article>
          ))}
        </div>

        <p className="curriculum-footnote">
          {hasBrochure
            ? 'The official brochure is free. Share your name and mobile number to unlock the download.'
            : `Detailed syllabus for ${courseName} is available on request from our counsellors.`}
        </p>
      </div>
    </section>
  );
}
